const currentTbVersion = Object.freeze({
major: 9,
minor: 1,
patch: 0,
label: "+rel.15.ca88f19"
});
export default currentTbVersion;



//////////////////
// WEBPACK FOOTER
// ./src/config/CurrentTbVersion.js
// module id = cVSd
// module chunks = 1